// prettier-ignore
export const AMP_RUBICON_SRID = {
  '/6782/AMP_GenAptTherapy/AmpPost/Sticky': '14682-amp-GenAptTherapy_Sticky',
  '/6782/AMP_GenAptTherapy/AmpPost/Recirc': '14682-amp-GenAptTherapy_Recirc',
  '/6782/AMP_GenAptTherapy/AmpPost': '14682-amp-GenAptTherapy_AmpPost',
  '/6782/AMP_GenAptTherapy/AmpPost/AmpPost_001': '14682-amp-GenAptTherapy_AmpPost_001',
  '/6782/AMP_GenAptTherapy/AmpPost/AmpPost_002': '14682-amp-GenAptTherapy_AmpPost_002',
  '/6782/AMP_GenAptTherapy/AmpPost/AmpPost_003': '14682-amp-GenAptTherapy_AmpPost_003',
  '/6782/AMP_GenAptTherapy/AmpPost/AmpPost_004': '14682-amp-GenAptTherapy_AmpPost_004',
  '/6782/AMP_GenAptTherapy/AmpPost/AmpPost_005': '14682-amp-GenAptTherapy_AmpPost_005',
  '/6782/AMP_GenAptTherapy/AmpPost/AmpPost_006': '14682-amp-GenAptTherapy_AmpPost_006',
  '/6782/AMP_GenAptTherapy/AmpPost/AmpPost_007': '14682-amp-GenAptTherapy_AmpPost_007',
  '/6782/AMP_GenAptTherapy/AmpPost/AmpPost_008': '14682-amp-GenAptTherapy_AmpPost_008',
  '/6782/AMP_GenAptTherapy/AmpPost/AmpPost_009': '14682-amp-GenAptTherapy_AmpPost_009',
  '/6782/AMP_GenAptTherapy/AmpPost/AmpPost_010': '14682-amp-GenAptTherapy_AmpPost_010',
  '/6782/AMP_GenAptTherapy/AmpPost/AmpPost_011': '14682-amp-GenAptTherapy_AmpPost_011',
  '/6782/AMP_GenAptTherapy/AmpPost/AmpPost_012': '14682-amp-GenAptTherapy_AmpPost_012',
  '/6782/AMP_GenAptTherapy/AmpGallery': '14682-amp-GenAptTherapy_AmpGallery',
  '/6782/AMP_GenAptTherapy/AmpGallery/AmpGallery_001': '14682-amp-GenAptTherapy_AmpGallery_001',
  '/6782/AMP_GenAptTherapy/AmpGallery/AmpGallery_002': '14682-amp-GenAptTherapy_AmpGallery_002',
  '/6782/AMP_GenAptTherapy/AmpGallery/AmpGallery_003': '14682-amp-GenAptTherapy_AmpGallery_003',
  '/6782/AMP_GenAptTherapy/AmpGallery/AmpGallery_004': '14682-amp-GenAptTherapy_AmpGallery_004',
  '/6782/AMP_GenAptTherapy/AmpGallery/AmpGallery_005': '14682-amp-GenAptTherapy_AmpGallery_005',
  '/6782/AMP_GenAptTherapy/AmpGallery/AmpGallery_006': '14682-amp-GenAptTherapy_AmpGallery_006',
  '/6782/AMP_GenAptTherapy/AmpGallery/AmpGallery_007': '14682-amp-GenAptTherapy_AmpGallery_007',
  '/6782/AMP_GenAptTherapy/AmpGallery/AmpGallery_008': '14682-amp-GenAptTherapy_AmpGallery_008',
  '/6782/AMP_GenAptTherapy/AmpGallery/AmpGallery_009': '14682-amp-GenAptTherapy_AmpGallery_009',
  '/6782/AMP_GenAptTherapy/AmpGallery/AmpGallery_010': '14682-amp-GenAptTherapy_AmpGallery_010',
  '/6782/AMP_GenAptTherapy/AmpGallery/AmpGallery_011': '14682-amp-GenAptTherapy_AmpGallery_011',
  '/6782/AMP_GenAptTherapy/AmpGallery/AmpGallery_012': '14682-amp-GenAptTherapy_AmpGallery_012'
};

export const TRIPLE_LIFT_DEFAULT_CODE = 'apartmenttherapy_leaderboard';

export const TRIPLE_LIFT_RAIL_CODE = 'apartmenttherapy_article_300x600';

export const TRIPLE_LIFT_STICKY_CODE = 'apartmenttherapy_320x50_sticky_hdx';

export const TRIPLE_LIFT_INSTREAM_VIDEO =
  'apartmenttherapy_ros_prebid_instream';

export const RUBICON_ACCOUNT_ID = '14682';

export const RUBICON_SITE_ID = '322896';

export const RUBICON_DEFAULT_ZONE_ID = '1681646';

export const TEADS_PAGE_ID = 120096;

export const TEADS_IN_POST_ID = 130227;

export const PUBMATIC_ACCOUNT_ID = '160137';

export const CATEGORY_BIDS = {
  'dfp-category-001-0': {
    appNexusId: 14759905,
    ixId: { desktop: 479019, tablet: 479020, phone: 479021 }
  },
  'dfp-category-002-0': {
    appNexusId: 14759906,
    ixId: { desktop: 479022, tablet: 479023, phone: 479024 }
  },
  'dfp-category-003-0': {
    appNexusId: 14759907,
    ixId: { desktop: 479025, tablet: 479026, phone: 479027 }
  },
  'dfp-category-004-0': {
    appNexusId: 14759908,
    ixId: { desktop: 479028, tablet: 479029, phone: 479030 }
  },
  'dfp-category-005-0': {
    appNexusId: 14759909,
    ixId: { desktop: 479031, tablet: 479032, phone: 479033 }
  },
  'dfp-category-006-0': {
    appNexusId: 14759910,
    ixId: { desktop: 479034, tablet: 479035, phone: 479036 }
  },
  'dfp-category-007-0': {
    appNexusId: 14759911,
    ixId: { desktop: 479037, tablet: 479038, phone: 479039 }
  },
  'dfp-category-008-0': {
    appNexusId: 14759912,
    ixId: { desktop: 479040, tablet: 479041, phone: 479042 }
  },
  'dfp-category-009-0': {
    appNexusId: 14759913,
    ixId: { desktop: 479043, tablet: 479044, phone: 479045 }
  },
  'dfp-category-010-0': {
    appNexusId: 14759914,
    ixId: { desktop: 479046, tablet: 479047, phone: 479048 }
  },
  'dfp-category-011-0': {
    appNexusId: 14759915,
    ixId: { desktop: 479049, tablet: 479050, phone: 479051 }
  },
  'dfp-category-012-0': {
    appNexusId: 14759916,
    ixId: { desktop: 479052, tablet: 479053, phone: 479054 }
  }
};

export const COLLECTION_BIDS = {
  'dfp-collection-001-0': {
    appNexusId: 14759853,
    ixId: { desktop: 478983, tablet: 478984, phone: 478985 }
  },
  'dfp-collection-002-0': {
    appNexusId: 14759854,
    ixId: { desktop: 478986, tablet: 478987, phone: 478988 }
  },
  'dfp-collection-003-0': {
    appNexusId: 14759855,
    ixId: { desktop: 478989, tablet: 478990, phone: 478991 }
  },
  'dfp-collection-004-0': {
    appNexusId: 14759856,
    ixId: { desktop: 478992, tablet: 478993, phone: 478994 }
  },
  'dfp-collection-005-0': {
    appNexusId: 14759857,
    ixId: { desktop: 478995, tablet: 478996, phone: 478997 }
  },
  'dfp-collection-006-0': {
    appNexusId: 14759858,
    ixId: { desktop: 478998, tablet: 478999, phone: 479000 }
  },
  'dfp-collection-007-0': {
    appNexusId: 14759859,
    ixId: { desktop: 479001, tablet: 479002, phone: 479003 }
  },
  'dfp-collection-008-0': {
    appNexusId: 14759860,
    ixId: { desktop: 479004, tablet: 479005, phone: 479006 }
  },
  'dfp-collection-009-0': {
    appNexusId: 14759861,
    ixId: { desktop: 479007, tablet: 479008, phone: 479009 }
  },
  'dfp-collection-010-0': {
    appNexusId: 14759862,
    ixId: { desktop: 479010, tablet: 479011, phone: 479012 }
  },
  'dfp-collection-011-0': {
    appNexusId: 14759863,
    ixId: { desktop: 479013, tablet: 479014, phone: 479015 }
  },
  'dfp-collection-012-0': {
    appNexusId: 14759864,
    ixId: { desktop: 479016, tablet: 479017, phone: 479018 }
  }
};

export const HOME_BIDS = {
  'dfp-home-001-0': {
    appNexusId: 14759866,
    ixId: { desktop: 478947, tablet: 478948, phone: 478949 }
  },
  'dfp-home-002-0': {
    appNexusId: 14759867,
    ixId: { desktop: 478950, tablet: 478951, phone: 478952 }
  },
  'dfp-home-003-0': {
    appNexusId: 14759868,
    ixId: { desktop: 478953, tablet: 478954, phone: 478955 }
  },
  'dfp-home-004-0': {
    appNexusId: 14759869,
    ixId: { desktop: 478956, tablet: 478957, phone: 478958 }
  },
  'dfp-home-005-0': {
    appNexusId: 14759870,
    ixId: { desktop: 478959, tablet: 478960, phone: 478961 }
  },
  'dfp-home-006-0': {
    appNexusId: 14759871,
    ixId: { desktop: 478962, tablet: 478963, phone: 478964 }
  },
  'dfp-home-007-0': {
    appNexusId: 14759872,
    ixId: { desktop: 478965, tablet: 478966, phone: 478967 }
  },
  'dfp-home-008-0': {
    appNexusId: 14759873,
    ixId: { desktop: 478968, tablet: 478969, phone: 478970 }
  },
  'dfp-home-009-0': {
    appNexusId: 14759874,
    ixId: { desktop: 478971, tablet: 478972, phone: 478973 }
  },
  'dfp-home-010-0': {
    appNexusId: 14759875,
    ixId: { desktop: 478974, tablet: 478975, phone: 478976 }
  },
  'dfp-home-011-0': {
    appNexusId: 14759876,
    ixId: { desktop: 478977, tablet: 478978, phone: 478979 }
  },
  'dfp-home-012-0': {
    appNexusId: 14759877,
    ixId: { desktop: 478980, tablet: 478981, phone: 478982 }
  }
};

export const POST_BIDS = {
  'dfp-post-001-0': {
    appNexusId: 14759878,
    ixId: { desktop: 479055, tablet: 479056, phone: 479057 }
  },
  'dfp-post-002-0': {
    appNexusId: 14759879,
    ixId: { 'post-large': 479058, 'post-small': 479060 },
    teadsId: TEADS_IN_POST_ID
  },
  'dfp-post-003-0': {
    appNexusId: 14759880,
    ixId: { 'post-large': 479061, 'post-small': 479063 },
    teadsId: TEADS_IN_POST_ID
  },
  'dfp-post-004-0': {
    appNexusId: 14759881,
    ixId: { 'post-large': 479064, 'post-small': 479066 },
    teadsId: TEADS_IN_POST_ID
  },
  'dfp-post-005-0': {
    appNexusId: 14759882,
    ixId: { 'post-large': 479067, 'post-small': 479069 },
    teadsId: TEADS_IN_POST_ID
  },
  'dfp-post-006-0': {
    appNexusId: 14759883,
    ixId: { 'post-large': 479070, 'post-small': 479072 },
    teadsId: TEADS_IN_POST_ID
  },
  'dfp-post-007-0': {
    appNexusId: 14759884,
    ixId: { 'post-large': 479073, 'post-small': 479075 },
    teadsId: TEADS_IN_POST_ID
  },
  'dfp-post-008-0': {
    appNexusId: 14759885,
    ixId: { 'post-large': 479076, 'post-small': 479078 },
    teadsId: TEADS_IN_POST_ID
  },
  'dfp-post-009-0': {
    appNexusId: 14759886,
    ixId: { 'post-large': 479079, 'post-small': 479081 },
    teadsId: TEADS_IN_POST_ID
  },
  'dfp-post-010-0': {
    appNexusId: 14759887,
    ixId: { 'post-large': 479082, 'post-small': 479084 },
    teadsId: TEADS_IN_POST_ID
  },
  'dfp-post-011-0': {
    appNexusId: 14759888,
    ixId: { 'post-large': 479085, 'post-small': 479087 },
    teadsId: TEADS_IN_POST_ID
  },
  'dfp-post-012-0': {
    appNexusId: 14759889,
    ixId: { 'post-large': 479088, 'post-small': 479090 },
    teadsId: TEADS_IN_POST_ID
  },
  'dfp-right-rail-0': {
    appNexusId: 14759890,
    ixId: 479091,
    tripleLiftId: TRIPLE_LIFT_RAIL_CODE,
    teadsId: 131947 // Unique id for rail
  },
  'dfp-footer-0': {
    appNexusId: 14759891,
    ixId: { desktop: 479093, tablet: 479094, phone: 479094 } // Tablet and phone use the same id
  },
  'dfp-sticky-0': {
    appNexusId: 14759892,
    ixId: 479095,
    tripleLiftId: TRIPLE_LIFT_STICKY_CODE
  }
};

export const VIDEO_BIDS = {
  'jw-player-right-rail-1': {
    path: '/6782/GenAptTherapy/Video/Rail',
    appNexusId: 16695856,
    ixId: 459105,
    pubmaticId: 3352177,
    rubiconId: 1897806,
    tripleLiftId: TRIPLE_LIFT_INSTREAM_VIDEO
  },
  'jw-player-related-1': {
    path: '/6782/GenAptTherapy/Video/Related',
    appNexusId: 16695859,
    ixId: 459106,
    pubmaticId: 3352178,
    rubiconId: 1897810,
    tripleLiftId: TRIPLE_LIFT_INSTREAM_VIDEO
  },
  'jw-player-in-post-1': {
    path: '/6782/GenAptTherapy/Video/InPost',
    appNexusId: 16695865,
    ixId: 459107,
    pubmaticId: 3352179,
    rubiconId: 1897816,
    tripleLiftId: TRIPLE_LIFT_INSTREAM_VIDEO
  }
};

// TEMP: Galleries no longer includes ads
/*
export const GALLERY_BIDS = {
  'dfp-gallery-001-0': {
    appNexusId: 14759893,
    ixId: 334533
  },
  'dfp-gallery-002-0': {
    appNexusId: 14759894,
    ixId: 334534
  },
  'dfp-gallery-003-0': {
    appNexusId: 14759895,
    ixId: 334535
  },
  'dfp-gallery-004-0': {
    appNexusId: 14759896,
    ixId: 334536
  },
  'dfp-gallery-005-0': {
    appNexusId: 14759897,
    ixId: 334537
  },
  'dfp-gallery-006-0': {
    appNexusId: 14759898,
    ixId: 334538
  },
  'dfp-gallery-007-0': {
    appNexusId: 14759899,
    ixId: 334539
  },
  'dfp-gallery-008-0': {
    appNexusId: 14759900,
    ixId: 334540
  },
  'dfp-gallery-009-0': {
    appNexusId: 14759901,
    ixId: 334541
  },
  'dfp-gallery-010-0': {
    appNexusId: 14759902,
    ixId: 334542
  },
  'dfp-gallery-011-0': {
    appNexusId: 14759903,
    ixId: 334543
  },
  'dfp-gallery-012-0': {
    appNexusId: 14759904,
    ixId: 334544
  }
};
*/
